import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');
const localize = createLocale('freelancerKVKInformationPageLocales');

export const KVKNumberSchema = Yup.object().shape({
  kvk_nummer: Yup.string()
    .required(localize('errorKVKNumberEmpty'))
    .matches(/^\d+$/, globalLocalize('numberTypeError'))
    .min(8, localize('errorKVKNumberLength', { length: 8 }))
    .max(8, localize('errorKVKNumberLength', { length: 8 })),
});

export const KVKDataSchema = Yup.object().shape({
  address: Yup.string().required(globalLocalize('fieldRequiredErrorMessage')),
  company_name: Yup.string().required(
    globalLocalize('fieldRequiredErrorMessage'),
  ),
  sbi_codes: Yup.string().required(globalLocalize('fieldRequiredErrorMessage')),
});
